export default function ResourceAdvantagePathway() {
  return <div>ResourceAdvantagePathway</div>;
}
